<template>
    <!-- protocol_search_container : S -->
    <div class="protocol_search_container">
        <div class="protocol_view_container">
            <div class="view_top_btn">
                <a href="javascript:void(0);" class="back_btn" @click="$emit('goToList');">목록으로</a>
            </div>
            <div class="view_head">
                <div class="protocol_search_item">
                    <div class="top_info">
                        <div class="txt_cont">
                            <div class="tit_label">
                                <span v-if="uniqueNumber" class="label_color color_01">{{uniqueNumber}}</span>
                                <span v-else class="label_color color_01">{{"공정도"}}</span>
                                <span class="label_gray">{{`${fieldName.split(">").join(" / ")}`}}</span>
                            </div>
                            <div class="tit_link" v-html="processName">
                            </div>
                            <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                            <!--                영문 한글명 토글 구현시 사용.-->
                            <!--                <p class="txt_info" v-html="processEngName"></p>-->
                            <!--                키워드의 경우 아직 관리되고 있지 않음.-->
                            <!--                <p class="txt_info">Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>-->
                        </div>
                        <div class="img_cont">
                            <div class="img_box">
                                <img :src="`data:image/jpeg;base64,${thumbnail}`" class="template"/>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_info">
                        <ul class="user_set">
                            <li>{{lastEditDate}}
                            </li>
                            <li>책임작성자 : {{userData.name}}</li>
                            <li v-if="collaborators.length > 1">공동작성자 :
                                <span
                                        v-for="(collaborator,collaboratorKey) in collaborators"
                                        :key="collaboratorKey"
                                        v-if="collaboratorKey > 0"
                                >{{`${collaboratorKey != 1 ? " ,"+collaborator.name :collaborator.name}`}}</span>
                            </li>
                        </ul>
                        <ul class="btn_set">
                            <li><a href="javascript:void(0);" class="writer_more_btn"
                                   :class="writerListActive?'on':null" @click="writerListActive = !writerListActive">작성자
                                더보기</a></li>
                            <li v-if="thisMyPage">
                                <a href="javascript:void(0);" 
                                   v-if="thisMyPage" 
                                   @click="$emit('goToProcessEditor');" 
                                   class="editor_move_btn">에디터로 이동
                                </a>
                            </li>
<!--                            <li class="process">
                                <a href="javascript:void(0);" class="process_chart_btn"
                                   @click="includedProtocolsActive = (!protocols?.length) ? (protocolCount == 0 ? false : true) : (true) ">
                                    포함된 프로토콜<span
                                        class="count"><strong>{{` ${ (!protocols?.length) ? (protocolCount == 0 ? 0 : protocolCount) : (protocols?.length) } `}}</strong>건</span>
                                </a>
                            </li>-->
                        </ul>
                    </div>
                </div>
                <ul class="protocol_writer_list" :class="writerListActive?'on':null"> <!--on-->
                    <li
                            v-for="(collaborator,collaboratorKey) in collaborators"
                            :key="collaboratorKey"
                    >
                        <ul class="writer_info">
                            <li class="user_name">
                                <div class="ico">
                                    <span class="icon_img"></span>
                                    <!--                                    <span class="icon_img txt">개정</span>-->
                                </div>
                                <div class="name">
                                    <strong>{{collaborator.name}}</strong>
                                    <span>{{`${collaboratorKey == 0 ? "책임작성자" : "공동작성자"}`}}</span>
                                </div>
                            </li>
                            <li>
                                <label>이메일</label>
                                <p>{{`${collaborator.email?.length > 0 ? collaborator.email : "-"}`}}</p>
                            </li>
                            <li>
                                <label>전화번호</label>
                                <p>{{`${collaborator.mobile?.length > 0 ? collaborator.mobile : "-"}`}}</p>
                            </li>
                            <li>
                                <label>소속</label>
                                <p>{{`${collaborator.companyName?.length > 0 ? collaborator.companyName : "-"}`}}</p>
                            </li>
                            <li>
                                <label>직책</label>
                                <p>{{`${collaborator.position?.length > 0 ? collaborator.position :
                                    "-"}`}}</p>
                            </li>
                            <li>
                                <label>팩스</label>
                                <p>{{`${collaborator.fax?.length > 0 ? collaborator.fax :
                                    "-"}`}}</p>
                            </li>
                            <li>
                                <label>직장전화번호</label>
                                <p>{{`${collaborator.companyPhone?.length > 0 ? collaborator.companyPhone : "-"}`}}</p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- view_head : E -->
            <div class="view_body">
                <!--                개요 데이터의 경우 현재 관리되고 있지 않기 때문에 주석처리.-->
<!--                <dl class="info_accodian" :class="infoAccodianActive?'open':null"> &lt;!&ndash;open&ndash;&gt;-->
<!--                    <dt-->
<!--                            @click="infoAccodianActive = !infoAccodianActive"-->
<!--                    >개요-->
<!--                    </dt>-->
<!--                    <dd>-->
<!--                        &lt;!&ndash;고성능 물질의 수요가 증가함에 따라, 표면 가공의 중요성도 커지고 있습니다. 물질의 표면은 외부 환경 및 기타 재질과 상호 작용하는 지점이며 부식율, 촉매-->
<!--                        활성, 접착제-->
<!--                        속성, 습윤성, 접촉 가능성 및 고장 메커니즘 등의 요인에 영향을 미칩니다. 이러한 특성을 변경 또는 개선하는 데 표면 수정이 활용될 수 있으며, 표면 분석은-->
<!--                        표면의 화학적-->
<!--                        특성을 이해하고 표면 가공의 효과를 검사하는 데 사용됩니다. 비접착성 조리기구 코팅부터 박막 전자 제품 및 바이오 활성 표면에 이르기까지, X선 광전자-->
<!--                        분광학은 표면 특성-->
<!--                        분석을 위한 표준 도구 중 하나입니다. X선 광전자 분광법(XPS)은 화학 분석(ESCA)을 위한 전자 분광 분석법으로도 알려져 있으며, 물질의 표면 화학-->
<!--                        특성을 분석하는-->
<!--                        기법입니다. XPS는 원소 구성은 물론 물질 내 원자의 화학적, 전자적 상태도 측정할 수 있습니다.&ndash;&gt;-->
<!--                    </dd>-->
<!--                </dl>-->
                <div class="protocol_map">
                    <div id="preview-process" class="editor"></div>
                    <editorOptions :diagram="diagram">
                        <div class="overviewWrap">
<!--                          <button class="mapOpen"  @click="overviewStatus = !overviewStatus">Map</button>-->
                        </div>
                        <div class="overview_wrap">
                          <div class="overview" :class="{on: overviewStatus}">
                              <div class="title_area">
                                  <strong class="tit">Map</strong>
                              </div>
                              <div id="editor-overview" class="editor_overview"></div>
                          </div>
                        </div>
                    </editorOptions>
                </div>
            </div>
        </div>
        <!--         protocol_view_container : E -->
        <IncludedProtocols
                :inProcessId="inProcessId"
                :lastEditDate="lastEditDate"
                :active="includedProtocolsActive"
                :publishingActive="publishingActive"
                @goToDetail="goToDetail"
                @close="includedProtocolsActive = false"
        />
        <Loading :visible="loading" type="fixed"/>
    </div>
    <!-- protocol_search_container : E -->
</template>

<script>
    import CommNew from "@processEditor/CommNew";
    import mixin from "@/mixins/process";
    import GO from "gojs";

    import editorOptions from '@nav_process/Editor/options';
    import IncludedProtocols from "@/components/modal/IncludedProtocols";
    import Loading from '@common/loading.vue'

    const goMake = GO.GraphObject.make;

    export default {
        props: {
            processDetailData: {type: Object, default: {}},
            thisMyPage: {
                type: Boolean, default: false
            },
            publishingActive: {
                type: Boolean, default: false
            },
        },
        data() {
            return {
                inProcessId: 0,
                fieldName: "",
                protocols: [],
                collaborators: [],
                processName: "",
                processEngName: "",
                thumbnail: null,
                userData: {},
                active: false,
                title: '',
                diagram: null,
                overview: null,
                overviewStatus: false,
                writerListActive: false,
                infoAccodianActive: false,
                includedProtocolsActive: false,
                lastEditDate: "",
                // 제정일
                enactmentDate: "",
                // 개정일
                revisionDate: "",
                releaseDate: "",
                uniqueNumber: null,
                protocolCount: 0,
                
                loading: false,
            }
        },
        components: {
            editorOptions,
            IncludedProtocols,
            Loading,
        },
        mixins: [mixin, CommNew],
        watch: {
            async processDetailData() {
                this.init();
                this.diagramInit();
                const nodes = JSON.parse(this.processDetailData.json);
                this.setNodeData(nodes);
            }
        },
        async mounted() {
            this.init();
            this.diagramInit();
            let nodes = {
                nodes : [],
                links : [],
            };
            if(this.processDetailData.json) {
                nodes = JSON.parse(this.processDetailData.json);
            }
            this.setNodeData(nodes);
        },
        methods: {
            async init() {
                if (!this.processDetailData) return;
                for (const item of Object.entries(this.processDetailData)) {
                    switch (item[0]) {
                        case "processId":
                            this["inProcessId"] = item[1];
                            break
                        case "user":
                            continue;
                            break
                        case "protocolId": // store에서 사용중인 computed 이름.
                            continue;
                            break
                        case "name":
                            this["processName"] = item[1];
                            break
                        default :
                            this[item[0]] = item[1];    
                    }
                }
                
                
                // 공개 데이터가 아님 (작성목록)
                if(!this.releaseDate) {
                    // 최종 수정일 또는 생성일 화면에 보여줄 형식에 맞게 수정.
                    if (!this.updatedDate) {
                        this.lastEditDate = this.createdDate?.substring(0, 10).split('-').join('.');
                    } else {
                        this.lastEditDate = this.updatedDate?.substring(0, 10).split('-').join('.');
                    }
                    this.collaborators.unshift(this.userData);
                    this.enactmentDate = this.enactmentDate?.substring(0, 10).split('-').join('.');
                    this.revisionDate = this.revisionDate?.substring(0, 10).split('-').join('.');
                }else{
                    this.collaborators.unshift(this.userData);
                    this.lastEditDate = this.releaseDate.substring(0, 10).split('-').join('.');
                    this.enactmentDate = this.lastEditDate;
                    this.revisionDate = this.revisionDate?.substring(0, 10).split('-').join('.');
                }
                
                /** 로그 등록 */
                await this.$wApi.trace.log({
                    type: 'PD', //PD 공정도, PR 프로토콜
                    code: 'R', //N 생성 M 수정 S 검색 R 조회
                    subCode: '01',
                    keyword: '',
                    result: 1,
                    ptlId: this.inProcessId
                });
            },
            diagramInit() {
                //GoJS 객체는 한 패널에만 속할 수 있어, 재호출 시 템플릿을 새로 만들어야 한다.
                this.releaseDiagram();
                this.refreshNodeStyleMap();
                const nodeTemplateMapped = new GO.Map();

                this.nodeStyleMap.forEach((nodeData, key) => {
                    nodeTemplateMapped.add(
                        `${key}`,
                        goMake(
                            GO.Node, 'Spot', {
                                cursor: 'pointer',
                                margin: 2,
                                locationSpot: GO.Spot.Center,
                                doubleClick: (event, node ) =>{
                                    if (node.data.category == "PROTOCOL" && node.data.protocol == 1) {
                                        let links = node.findLinksInto();
                                        let equipmentData = null;
                                        links.each((link)=>{
                                            let fromNode = link.fromNode;
                                            if(fromNode.data.category === 'EQUIPMENT'){
                                                equipmentData = fromNode.data;
                                                return;
                                            }
                                        });
                                        this.callGoToDetail(equipmentData.key);
                                    }else if(node.data.protocol > 1){
                                        window.alert("<b>프로토콜이 다건인 정보의<br/>상세 페이지 이동은 개발 진행중 입니다.<br/><br/>우측 상단의 포함된 프로토콜 팝업을 이용해 주세요.</b>");
                                    }
                                },
                            },
                            new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
                            goMake(GO.Panel, 'Auto',
                                ...nodeData.nodeTemplate,
                            ),
                        ),
                    )
                })

                this.diagram = new GO.Diagram("preview-process", {
                    layout: goMake(GO.TreeLayout, {
                        isOngoing: false,
                        isInitial: false
                    }),
                    // layout: goMake(GO.TreeLayout),
                    "undoManager.isEnabled": true,
                    // 확대 정도
                    scale: 1,
                    maxScale: 3,
                    minScale: 0.2,
                    scrollMargin: 15,
                    nodeTemplateMap: nodeTemplateMapped,
                    linkTemplate: this.linkTemplate,
                });
                this.diagram.isReadOnly = true;
                this.diagram.isVirtualized = true;
                this.diagram.padding = new GO.Margin(120, 0, 150, 0);
                this.overview = new GO.Overview('editor-overview', {
                    observed: this.diagram
                })

                this.diagram.addDiagramListener('InitialLayoutCompleted', (event) => {
                    event.diagram.nodes.each((node) => {
                        if ((
                            node.data.category === 'PROTOCOL' &&
                            typeof node.data.protocol === 'number' &&
                            node.data.protocol > 0
                        )
                        ) {
                            node.findObject('protocolCount').text = node.data.protocol;
                        }
                    });
                });
                this.diagram.isVirtualized = false;
            },
            setNodeData(data) {
                if (!this.thisMyPage) {
                    data.nodes.filter(o => o.category === 'PROTOCOL').forEach((node) => {
                        node.protocol = 0;
                    });

                    // 공개되었으며 연결된 프로토콜 개수 setting
                    let equipmentTags = data.nodes.filter(o=>o.category==='EQUIPMENT');
                    // protocols => 
                    let fullProtocols = [];
                    for( let equipment of equipmentTags  ){
                      let fullProtocol = this.protocols.filter(o=>o.innerKeyOfProtocol==equipment.key);
                      if( fullProtocol.length > 0 ){
                        fullProtocols.push({ 
                          key : equipment.key,
                          count : fullProtocol.length // 연결된 프로토콜 수량을 저장.
                        } );
                      }
                    }

                    for( let fullProtocol of fullProtocols ){
                      let protocolKey = data.links.find(o=>o.from===fullProtocol.key).to;
                        data.nodes.find(o=>o.key === protocolKey && o.category==='PROTOCOL').protocol = fullProtocol.count;
                    }

                } else {
                    data.nodes.filter(o => o.category === 'PROTOCOL').forEach((node) => {
                        node.protocol = 0;
                    });

                    // 공개되었으며 연결된 프로토콜 개수 setting
                    let equipmentTags = data.nodes.filter(o=>o.category==='EQUIPMENT');
                    // protocols => 
                    let fullProtocols = [];
                    for( let equipment of equipmentTags  ){
                      let fullProtocol = this.protocols.filter(o=>o.innerKeyOfProtocol==equipment.key && (o.onlyProtocolPublicActive > 0 || o.showMode));
                      if( fullProtocol.length > 0 ){
                        fullProtocols.push({ 
                          key : equipment.key,
                          count : fullProtocol.length // 연결된 프로토콜 수량을 저장.
                        } );
                      }
                    }

                    for( let fullProtocol of fullProtocols ){
                      let protocolKey = data.links.find(o=>o.from===fullProtocol.key).to;
                        data.nodes.find(o=>o.key === protocolKey && o.category==='PROTOCOL').protocol = fullProtocol.count;
                    }
                }
                this.diagram.model = new GO.GraphLinksModel(
                    {
                        nodeDataArray: data.nodes,
                        linkDataArray: data.links,
                    }
                );
            },
            goToDetail(protocolId, viewMode, tabIndex) {
                const beforeProcessId = this.inProcessId;
                this.$emit("goToProtocolDetail", protocolId, viewMode, tabIndex, beforeProcessId);
            },
            callGoToDetail(key) {
                try {
                    this.loading = true;
                    if(!this.thisMyPage) { // 통합검색
                        let targetProtocol = this.protocols.filter(protocol => protocol.innerKeyOfProtocol == key)[0];
                        if (targetProtocol.publicActive > 1) {
                            if (this.user.admin || this.user.assistant || this.user.committee || this.user.generalManager || this.user.super) {
                                this.goToDetail(targetProtocol.protocolId, "tree", 1);
                            } else {
                                window.alert("위원/간사 이상 조회 가능한 프로토콜 입니다.");
                            }
                        } else {
                            this.goToDetail(targetProtocol.protocolId, "tree", 1);
                        }
                        this.loading = false;
                    }else{
                        let targetProtocol = this.protocols.filter(protocol=>protocol.innerKeyOfProtocol==key && (protocol.onlyProtocolPublicActive > 0 || protocol.showMode))[0];
                        this.goToDetail(targetProtocol.protocolId, "tree", 1);
                    }
                }catch (e) {
                    this.loading = false;
                    window.alert("프로토콜 정보 조회중 오류가 발생했습니다.");
                }finally {
                    this.loading = false;
                }
            },
        }
    }
</script>